module.exports = __webpack_public_path__ + "static/media/3.b1eda209.png";